<template>
  <div>
    <div class="r-text-intro">
      היי {{this.firstName}}, שמחים שחזרת!
    </div>
    <div class="r-text-headline-paragraph">
      <div>קופת הגמל להשקעה שלך</div>
      <div>ב׳מיטב׳ נפתחה בהצלחה.</div>
    </div>

    <div class="r-text-headline-paragraph">
      <div class="r-text-intro">מספר חשבון ב׳מיטב׳</div>
      <div>{{this.fundNumber}}</div>
    </div>

    <div class="r-text-intro">לעוד פרטים:</div>
    <div>
      <out-of-flow-button icon="face" text="האזור האישי שלך ב׳מיטב׳" @click="redirectToMeitavDash" />
      <out-of-flow-button icon="sms" text="פנייה לצוות riseup" flipIcon @click="sendMail" />
    </div>
  </div>
</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import { mapState, mapActions } from 'vuex';
import ScrollToTop from '@/mixins/ScrollToTop';
import OutOfFlowButton from '@/components/styled/OutOfFlowButton';
import { MEITAV_DASH_PERSONAL_AREA } from '@/router/consts';

export default {
  name: 'FundApproved',
  mixins: [TrackedPage, ScrollToTop],
  components: {
    OutOfFlowButton,
  },
  methods: {
    ...mapActions('meitavDash/fundRequests', ['initFundRequests']),

    redirectToMeitavDash() {
      window.location.assign(MEITAV_DASH_PERSONAL_AREA);
    },
    sendMail() {
      window.open('mailto:saving@riseup.co.il');
    },
  },
  computed: {
    ...mapState('meitavDash/openFund', ['firstName']),
    ...mapState('meitavDash/fundRequests', ['fundNumber']),
  },
};
</script>
